export default "__VITE_ASSET__DSZ2cbnX__"